let itemHasChildren   = document.querySelectorAll( '#site-navigation .menu-item-has-children > a' );

itemHasChildren.forEach(element => {
    element.addEventListener('click', function(e) {
        e.preventDefault()
        
        let parent = element.closest('.menu-item-has-children')
        parent.querySelector('.sub-menu').classList.toggle('show')
        element.classList.toggle('active')
    });
})

/*itemHasChildren.forEach(element => {
    element.addEventListener('touchend', function(e) {
        e.preventDefault()
        
        let parent = element.closest('.menu-item-has-children')
        parent.querySelector('.sub-menu').classList.toggle('show')
        element.classList.toggle('active')
    });
})*/